import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import Basemap from "@arcgis/core/Basemap";
import { proxyUrl } from "../config";
import {
  proxyDomain,
  operationalMapUrl,
  operationalLayerUrl,
  baseMapLayers,
  operationalLayers,
  operationalLayerName,
} from "../appConfig";

import * as urlUtils from "@arcgis/core/core/urlUtils";
import SimpleRenderer from "@arcgis/core/renderers/SimpleRenderer";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import TileLayer from "@arcgis/core/layers/TileLayer";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";

urlUtils.addProxyRule({
  urlPrefix: proxyDomain,
  proxyUrl: proxyUrl,
});

export const mugisRenderer: SimpleRenderer = {
  type: "simple",
  symbol: {
    type: "simple-fill",
    color: null,
    style: "solid",
    outline: {
      // autocasts as new SimpleLineSymbol()
      color: [255, 0, 0, 0.05],
      width: 1,
    },
  } as any,
};

export const mugisPointRenderer: SimpleRenderer = {
  type: "simple", // autocasts as new SimpleMarkerSymbol()
  symbol: {
    type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
    style: "circle",
    color: [255, 0, 0, 0.05],
    size: "20px", // pixels
    outline: {
      // autocasts as new SimpleLineSymbol()
      color: [255, 0, 0, 0.0],
      width: 8,
    },
  } as any,
};

export const mugisPolylineRenderer: SimpleRenderer = {
  type: "simple", // autocasts as new SimpleMarkerSymbol()
  symbol: {
    type: "simple-line", // autocasts as new SimpleLineSymbol()
    color: [0, 255, 255, 0.1],
    width: "8px",
    style: "solid",
    join: "round",
    miterLimit: "20px",
  } as any,
};

export const mugisImgRenderer: SimpleRenderer = {
  type: "simple",
  symbol: {
    type: "simple-fill",
    color: null,
    style: "solid",
    outline: {
      // autocasts as new SimpleLineSymbol()
      color: "yellow",
      width: 1,
    },
  } as any,
};
let filteredOpLayer = operationalLayers.filter((opLayer: any, i: number) => {
  return opLayer.Key === operationalLayerName;
});

export const mugisOpLayer = new FeatureLayer({
  id: "mugis-OpLayer",
  title: filteredOpLayer[0].Key,
  geometryType: filteredOpLayer[0].GeometryType,
  listMode: "hide",
  legendEnabled: false,
  url: operationalLayerUrl,
  outFields: filteredOpLayer[0].OutFields,
  //fields: mugisFields, //["*"], //mugisFields,
  minScale: filteredOpLayer[0].minScale,
  spatialReference: new SpatialReference({ wkid: filteredOpLayer[0].spatialReferenceWkId }),
  labelsVisible: filteredOpLayer[0].labelsVisible,
  objectIdField: filteredOpLayer[0].ObjectIDField,
  renderer:
    filteredOpLayer[0].GeometryType === "point"
      ? mugisPointRenderer
      : filteredOpLayer[0].GeometryType === "polygon"
        ? mugisRenderer
        : mugisPolylineRenderer,
  popupTemplate: null,
});

const opMapUrl = operationalMapUrl;
export const operationalMapLayer = new MapImageLayer({
  url: opMapUrl,
  id: "operationalMap",
});

export const highlightGraphicLayer = new GraphicsLayer({
  id: "highlightGraphicLayer",
  title: "highlightGraphicLayer",
  listMode: "hide",
});
export const gisHighlightGraphicLayer = new GraphicsLayer({
  id: "gisHighlightGraphicLayer",
  title: "gisHighlightGraphicLayer",
  listMode: "hide",
});
export const displayResultsZoomHighGraphicLayer = new GraphicsLayer({
  id: "displayResultsZoomHighGraphicLayer",
  title: "displayResultsZoomHighGraphicLayer",
  maxScale: 4800,
  minScale: 0,
  opacity: 0.7,
  listMode: "hide",
});
export const displayResultsZoomLowGraphicLayer = new GraphicsLayer({
  id: "displayResultsZoomLowGraphicLayer",
  title: "displayResultsZoomLowGraphicLayer",
  maxScale: 0,
  minScale: 4799,
  opacity: 0.7,
  listMode: "hide",
});
export const displayResultsHoverGraphicLayer = new GraphicsLayer({
  id: "displayResultsHoverGraphicLayer",
  title: "displayResultsHoverGraphicLayer",
  opacity: 0.7,
  listMode: "hide",
});
export const sketchGraphicLayer = new GraphicsLayer({
  id: "sketchGraphicLayer",
  title: "sketchGraphicLayer",
  listMode: "hide",
});
export const clickGraphicLayer = new GraphicsLayer({
  id: "clickGraphicLayer",
  title: "clickGraphicLayer",
  listMode: "hide",
});
export const bufferGraphicLayer = new GraphicsLayer({
  id: "bufferGraphicLayer",
  title: "bufferGraphicLayer",
  listMode: "hide",
});
export const traceGraphicLayer = new GraphicsLayer({
  id: "traceGraphicLayer",
  title: "traceGraphicLayer",
  listMode: "hide",
});

///
/* const baseMapDefaultUrl = defaultBasemapToggleLayer;

const url = baseMapDefaultUrl;
const baseMapDefaultLayer = new MapImageLayer({ url })
export const defaultBaseMap = new Basemap({
  baseLayers: [baseMapDefaultLayer],
  title: "defaultBaseMap",
  id: "defaultBaseMap",
  thumbnailUrl: "./public/assets/basemap-toggle-reg.png"

});
const imageryBaseMapLayer = new MapImageLayer({
  url: imageryBaseMapToggleLayer
});

export const imageryBaseMap = new Basemap({
  baseLayers: [imageryBaseMapLayer],
  title: "imageryBaseMap",
  id: "imageryBaseMap",
  thumbnailUrl: "./public/assets/basemap-toggle.png"

}); */
///
export const baseMaps: Basemap[] = [];
baseMapLayers.forEach((baseMapLayer, idx) => {
  try {
    let layer = null;
    if (baseMapLayer.isTileLayer) {
      if (baseMapLayer.mapurl.indexOf("VectorTileServer") !== -1) {
        layer = new VectorTileLayer({ url: baseMapLayer.mapurl });
      } else {
        layer = new TileLayer({ url: baseMapLayer.mapurl });
      }
    } else {
      layer = new MapImageLayer({ url: baseMapLayer.mapurl });
    }
    baseMaps.push(
      new Basemap({
        baseLayers: [layer],
        title: baseMapLayer.title,
        id: baseMapLayer.keyname,
        thumbnailUrl: baseMapLayer.thumbnailsource,
      })
    );
  } catch (ex) {
    console.log("Error" + ex.message);
  }
});
